import React, { useEffect, useState } from "react";
import TiltArrow from "../../../icons/TiltArrow";
import { useRouter } from "next/router";
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "../../../shadcn/components/ui/tabs";
import LiveAuctionCard from "./LiveAuctionCard";

interface LiveAuctionCardProps {
  assetType: string;
  subAssetType: string;
  eventName: string;
  latestBidPrice: string;
  biddersCount: number;
  eventUuid: string;
}

interface LiveAuctionDataProps {
  title: string;
  value: string;
  children: LiveAuctionCardProps[];
}

interface props {
  eventsData?: any;
}

export const OngoingAuctionsComponent = ({ eventsData }: props) => {
  const router = useRouter();
  const [liveAuctionData, setLiveAuctionData] = useState<any>([]);

  const getBidPrice = (data: any) => {
    if (!Array.isArray(data) || data.length === 0) return "0";

    const finalAmount = data.reduce((max, item) => {
      const amount = Number(item.final_amount) || 0;
      return amount > max ? amount : max;
    }, 0);

    return new Intl.NumberFormat("en-IN").format(Number(finalAmount));
  };

  const getVerifiedBidders = (data: any) => {
    if (!Array.isArray(data) || data.length === 0) return 0;
    return data.filter((item) => item.status === "verified").length;
  };
  const filterLiveAuctionData = (data: any) => {
    if (!Array.isArray(data)) return;

    // Separate auctions into "With Bidders" and "Without Bidders"
    const withBidders: LiveAuctionCardProps[] = [];
    const withoutBidders: LiveAuctionCardProps[] = [];

    data?.forEach((event: any) => {
      const assetType = event?.property_dump?.asset?.name || "N/A";
      const subAssetType = event?.property_dump?.sub_asset_type?.name || "N/A";
      const eventName = event?.event_name || "N/A";
      const latestBidPrice =
        event?.bids?.length > 0 ? getBidPrice(event?.bids) : "0";
      const biddersCount =
        event?.bidders?.length > 0 ? getVerifiedBidders(event?.bidders) : 0;
      const eventUuid = event?.uuid || "N/A";

      const auctionItem = {
        assetType,
        subAssetType,
        eventName,
        latestBidPrice,
        biddersCount,
        eventUuid,
      };

      if (biddersCount > 0) {
        withBidders.push(auctionItem);
      } else {
        withoutBidders.push(auctionItem);
      }
    });

    // Structured data format
    const filteredData: LiveAuctionDataProps[] = [
      {
        title: "With Bidders",
        value: "with_bidders",
        children: withBidders.slice(0, 4),
      },
      {
        title: "Without Bidders",
        value: "without_bidders",
        children: withoutBidders.slice(0, 4),
      },
    ];

    setLiveAuctionData(filteredData);
  };

  useEffect(() => {
    if (eventsData) filterLiveAuctionData(eventsData);
  }, [eventsData]);

  return (
    <div className="bg-brand-bgLightGrey px-4 pt-4 w-full mid:max-w-[346px] mt-[32px] mid:mt-0">
      <div className="flex justify-between items-center sm:items-center">
        <p className="font-openSans font-semibold text-mobile-body-sm leading-4 lg:text-web-body-md lg:leading-5 text-brand-bgBlack">
          Ongoing Auctions
        </p>
        <p
          onClick={() => {
            router.push("/dashboard/events");
          }}
          className="font-openSans font-semibold text-web-body-sm leading-4 text-brand-bgBlack hover:cursor-pointer"
        >
          View All
        </p>
      </div>
      <Tabs defaultValue="with_bidders" className="w-full mt-4">
        <div className="overflow-auto scrollbar-hide">
          <TabsList className="w-full flex justify-evenly  gap-[21px] lg:gap-[30px] bg-white  font-openSans font-normal text-web-body-md lg:text-web-body-lg leading-4 text-[#A8A8A8]">
            {liveAuctionData?.map((item: any, index: number) => (
              <TabsTrigger
                value={item?.value}
                className="capitalize"
                key={`ongoing_auction_${item.value}_${index}`}
              >
                {item?.title}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>

        {liveAuctionData?.map((item: any, index: number) => (
          <TabsContent
            className="h-full py-2 scrollbar-hide overflow-y-auto"
            value={item.value}
            key={`${item.value}_${index}`}
          >
            <div className=" flex flex-col space-y-[14px]">
              {item?.children && item?.children?.length > 0 ? (
                item?.children?.map((event: any, index: any) => (
                  <LiveAuctionCard
                    key={`event_${event.eventUuid}_${index}`}
                    latestPrice={event?.latestBidPrice}
                    assetType={event.assetType}
                    subAssetType={event.subAssetType}
                    eventName={event.eventName}
                    biddersCount={event.biddersCount}
                    eventUuid={event.eventUuid}
                  />
                ))
              ) : (
                <div className="h-full flex flex-col justify-center bg-white">
                  <p className="font-openSans font-normal text-brand-bgBlack text-center  py-6 px-4">
                    No Live Auction Events at this moment
                  </p>
                </div>
              )}
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};

export default OngoingAuctionsComponent;
